"use client";

import styles from "./layout.module.scss";
import React from "react";
import Sidebar from "@/components/sidebar/sidebar";
import { useMobile } from "@/hooks/use-responsive";
import MobileHeader from "@/components/header/mobile-header/mobile-header";

const HomeLayout = ({ children }) => {
  const { isMobile } = useMobile();

  return (
    <main className={styles.main}>
      {!isMobile && <Sidebar />}
      <div className={styles.content}>
        {isMobile && <MobileHeader />}
        {children}
      </div>
    </main>
  );
};

export default HomeLayout;
